<template>
  <div class="mainNavigation no-print" v-bind:class="page">
    <!--Navbar-->
    <nav class="navbar navbar-dark" :style="'background-color: '+ backgroundColor">

      <!-- Collapse button-->
      <button class="navbar-toggler hidden-sm-up" type="button" data-toggle="collapse" data-target="#collapseEx">
        <i class="fa fa-bars"></i></button>

      <div class="container-fluid">
        <!--Collapse content-->
        <div class="collapse navbar-toggleable-xs" id="collapseEx">
          <!--Navbar Brand-->
          <router-link v-if="this.hideLogo === false" class="navbar-brand" :to="'/'+this.$store.state.language">booknatura</router-link>
          <!--Links-->
          <ul class="nav navbar-nav pull-right">
            <li class="nav-item supplier-nav-item">
              <router-link class="nav-link" :to="'/'+this.$store.state.language+'/supplier/'">{{t('suppliers')}}</router-link>
            </li>
            <li class="nav-item">
              <router-link v-if="page !== 'mainPage'" class="nav-link" to="/"><i class="fa fa-home"></i></router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="$store.state.user.data.username === ''" :to="'/'+this.$store.state.language+'/login'">{{t('login')}}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="$store.state.user.data.username === ''" :to="'/'+this.$store.state.language+'/register'">{{t('register')}}</router-link>
            </li>
            <li class="nav-item languageLink">
              <a class="nav-link" v-if="language !== 'pt'" v-on:click="setLanguage('pt')"><img src="/static/img/flag-pt.svg" alt="português" width="16"/></a>
              <img class="unselected" v-else src="/static/img/flag-pt.svg" alt="português" width="16"/>
            </li>
            <li class="nav-item languageLink">
              <a class="nav-link" v-if="language !== 'en'" v-on:click="setLanguage('en')"><img src="/static/img/flag-gb.svg" alt="english" width="16"/></a>
              <img class="unselected" v-else src="/static/img/flag-gb.svg" alt="english" width="16"/>
            </li>
            <UserMenu></UserMenu>
          </ul>
        </div>
        <!--/.Collapse content-->
      </div>

    </nav>
    <SecondaryNavigation v-if="showPromoterNav"></SecondaryNavigation>
    <UserNavigation v-if="shouldShowUserNavigation()"></UserNavigation>
    <ContactUsBar :page="page" v-if="!shouldShowUserNavigation() && !showPromoterNav"></ContactUsBar>
    </header>
    <!--/Navigation-->

  </div>
</template>

<script>
// import Headspace from 'headspace';
import { mapState } from 'vuex';
import UserMenu from './UserMenu';
import SecondaryNavigation from './SecondaryNavigation';
import UserNavigation from './UserNavigation';
import ContactUsBar from './ContactUsBar';

export default {
  name: 'Navigation',
  components: { UserMenu, SecondaryNavigation, UserNavigation, ContactUsBar },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      language: state => state.language,
      user: state => state.user.data,
    }),
  },
  props: {
    hideLogo: {
      default: false,
    },
    backgroundColor: {
      default: 'rgba(0,105,92, 0.9)',
    },
    page: {
      default: '',
    },
    showPromoterNav: {
      default: false,
    },
    showUserNav: {
      default: false,
    },
  },
  methods: {
    setLanguage(language) {
      const matchedPath = this.$route.fullPath;
      const routeArray = matchedPath.split('/');
      routeArray[1] = language;
      const newPath = routeArray.join('/');
      this.$root.$translate.setLang(language);
      this.$store.commit('setLanguage', language);
      this.$router.push(newPath);
      if (this.$route.matched.length === 2) {
        if (this.$route.matched[1].path === '/:lang/activity/:slug') {
          location.reload();
        }
      }
    },
    shouldShowUserNavigation() {
      if (!this.showUserNav) {
        return false;
      }
      /* if (this.user.username === '' || this.user.type !== 'user') {
        return false;
      } */
      return true;
    },
  },
  mounted() {
    // window.headspace = new Headspace(document.querySelector('.mainNavigation'));
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* grid-breakpoints */

/* Navigation*/
.mainNavigation {
  position: relative;
  z-index: 10000000000; /* because of the chat icon */
}
.mainNavigation.mainPage {
  top: 0;
  position: absolute;
  width: 100%;
}
.navbar {
  background-color: #00695C;
  box-shadow: none;
}

@media only screen and (max-width: 768px)
{
  .navbar {
    background-color: #1C2331;
  }
}

@media only screen and (max-width: 544px)
{
  .navbar {
    background-color: rgba(0,105,92, 0.9) !important;
    text-align: center;
    .nav-item {
      min-width: 100%;
    }
  }
}

.navbar-brand {
  background: url('../../../static/img/logo-booknatura-white.svg') no-repeat;
  background-size: contain;
  font-size: 0;
  text-indent: -9999px;

  width: 124px;
  height: 31px;
  margin-top: 4px;
}

.nav-item {
  a {
    font-weight: 200;
    letter-spacing: 0.02em;
    opacity: 0.9;
  }
  a:hover {
    opacity: 1;
    color: white !important;
  }
}

.supplier-nav-item {
  padding-right: 16px !important;
}

/**
 * Headspace starter styles
 */
.headspace {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.3s;
  height: 4rem;
}
.headspace--hidden {
  transform: translate3d(0, -8rem, 0); /* y value should be -1 * height */
}
.headspace--fixed {
  position: fixed;
}

/**
 * Optional feature: show header when hovering near top
 */
.headspace--hidden:after {
  content: '';
  position: fixed;
  left: 0;
  right: 0;
  top: 8rem;
  height: 8rem;
}
.headspace--hidden:hover {
  transform: translate3d(0, 0, 0);
}
.languageLink {
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
  a img {
    outline: 1px solid rgba(255,255,255, 0.6) !important;
  }
}
.languageLink .unselected {
  padding-top: calc(0.425rem);
  margin-bottom: -3px;
  vertical-align: bottom;
}
@media only screen and (max-width: map-get($grid-breakpoints, sm)) {
  .languageLink {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?cc3b530c